import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Landing from './Landing';
import LandingBold from './whitelabel/LandingBold';
import LandingMinimal from './whitelabel/LandingMinimal';
import LandingAgency from './whitelabel/LandingAgency';
import { resolveMediaUrl } from '../lib/mediaUrl';

/**
 * WhiteLabelLanding — agency-branded landing with selectable templates.
 */
const WhiteLabelLanding = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const base = process.env.REACT_APP_BACKEND_URL || '';
        const res = await fetch(`${base}/api/whitelabel/landing/${slug}`);
        if (!res.ok) throw new Error('Not found');
        setConfig(await res.json());
      } catch (e) {
        setConfig(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white" data-testid="wl-loading">
        <p className="text-sm text-zinc-400">Loading workspace…</p>
      </div>
    );
  }

  if (!config) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white" data-testid="wl-not-found">
        <p className="text-lg font-semibold mb-3">Workspace not found</p>
        <Button variant="outline" onClick={() => navigate('/')} data-testid="wl-home-button">Go to main site</Button>
      </div>
    );
  }

  const shared = {
    brand: config.brand_name || 'My Workspace',
    logoUrl: resolveMediaUrl(config.logo_url) || null,
    pricingPlans: config.pricing_cards || [],
    authPath: `/w/${slug}/auth`,
    primaryColor: config.primary_color || '#f97316',
  };

  const template = (config.landing_template || 'classic').toLowerCase();
  if (template === 'bold') return <LandingBold {...shared} />;
  if (template === 'minimal') return <LandingMinimal {...shared} />;
  if (template === 'agency') return <LandingAgency {...shared} />;

  return (
    <Landing
      brand={shared.brand}
      logoUrl={shared.logoUrl}
      pricingPlans={shared.pricingPlans}
      authPath={shared.authPath}
      primaryColor={shared.primaryColor}
    />
  );
};

export default WhiteLabelLanding;
